export default __webpack_public_path__ + "static/media/bg32.28d7d137.jpg";